export class ModulePageController {
    constructor($scope, contentUtilService) {
        'ngInject';

        contentUtilService.markAndTrustContentAsHtml($scope.content, 'body');
    }
}